import Vue from 'vue/dist/vue.esm';

export const EventBus = new Vue();

export const requestHeaders = {
  'X-Consumer-ID': '7e74e321-4c7d-4cf0-bfba-09e011474ef8',
};
